import { isRouteNameInRoute, logGuard } from '@/router/helpers';
import { RouteNameEnum } from '@/router/RouteName';
import { User } from '@/models/User';
export const guestMiddleware = async (to, _from) => {
    logGuard('[GUEST_MIDDLEWARE]', to);
    const user = await User.attemptLogin();
    if (user) {
        logGuard('[GUEST_MIDDLEWARE] user', user);
        return isRouteNameInRoute(RouteNameEnum.HOME, to)
            ? true
            : { name: RouteNameEnum.HOME };
    }
    logGuard('[GUEST_MIDDLEWARE] returning', true);
    return true;
};
